import { render, staticRenderFns } from "./SearchUserView.vue?vue&type=template&id=c66b97ea&"
import script from "./SearchUserView.vue?vue&type=script&lang=ts&"
export * from "./SearchUserView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports